import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useForm } from "react-hook-form";
import { FaEnvelope, FaPhone, FaTimes } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CustomizationForm({ onClose,setShowPopup }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [phone, setPhone] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const notifySuccess = () => toast.success("Form submitted successfully!");
  const notifyError = (message) => toast.error(message);

  const onSubmit = async (data) => {
    if (isSubmitting) return;

    if (!phone) {
      notifyError("Please enter a valid phone number with country code.");
      return;
    }

    const formData = {
      ...data,
      phone,
    };

    setIsSubmitting(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/customization`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        notifySuccess();
        reset();
        setPhone("");
      } else {
        const errorMessage = result.errors
          ? result.errors.join(", ")
          : result.message || "Submission failed";
        notifyError(errorMessage);
      }
    } catch (error) {
      console.error("Submission Error:", error);
      notifyError("Network error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="fixed z-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 grid grid-cols-2 gap-4 w-full max-w-5xl bg-white p-8 rounded-lg shadow-2xl overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 "
        style={{ maxHeight: "90vh", width: "90%" }}
      >
        
          <button
            type="button"
            
            onClick={() => setShowPopup(false)} 
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
          >
            
            <FaTimes size={24} />
          </button>
{/* 
<button
        onClick={() => setShowPopup(false)} // This will close the popup by setting showPopup to false
        className="mt-4 px-6 py-2 bg-gray-800 text-white rounded-lg shadow-md hover:bg-gray-700"
      >
        Close
      </button> */}

        <h2 className="col-span-2 text-2xl font-bold text-gray-800 mb-4 text-center">
          Customize Your Diamond
        </h2>

        {/* Mobile Number */}
        <div className="col-span-2 flex items-center gap-2">
          <FaPhone className="text-gray-600" />
          <label className="block text-gray-700 font-semibold mb-1">
            Mobile Number *
          </label>
        </div>
        <div className="col-span-2 md:col-span-1">
          <PhoneInput
            placeholder="Enter phone number"
            value={phone}
            onChange={setPhone}
            defaultCountry="US"
            className="w-full p-2 border rounded"
          />
          {!phone && (
            <p className="text-red-500 text-sm">Phone number is required.</p>
          )}
        </div>

        {/* Email */}
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2">
            <FaEnvelope className="text-gray-600" />
            <label className="block text-gray-700 font-semibold mb-1">
              Email Address *
            </label>
          </div>
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full p-2 border rounded"
            {...register("email", {
              required: "Email is required.",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address.",
              },
            })}
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email.message}</p>
          )}
        </div>

        {/* Select Shape */}
        <div className="col-span-2 md:col-span-1">
          <label className="block text-gray-700 font-semibold mb-1">
            Select Shape *
          </label>
          <select
            className="w-full p-2 border rounded"
            {...register("shape", { required: "Shape is required" })}
          >
            <option value="">Select Shape</option>
            <option value="Round">Round</option>
            <option value="Oval">Oval</option>
            <option value="Princess">Princess</option>
            <option value="Cushion">Cushion</option>
          </select>
          {errors.shape && (
            <p className="text-red-500 text-sm">{errors.shape.message}</p>
          )}
        </div>

        {/* Fluorescence */}
        <div className="col-span-2 md:col-span-1">
          <label className="block text-gray-700 font-semibold mb-1">
            Fluorescence *
          </label>
          <select
            className="w-full p-2 border rounded"
            {...register("fluorescence", {
              required: "Fluorescence is required",
            })}
          >
            <option value="">Select Fluorescence</option>
            <option value="None">None</option>
            <option value="Faint">Faint</option>
            <option value="Medium">Medium</option>
            <option value="Strong">Strong</option>
          </select>
          {errors.fluorescence && (
            <p className="text-red-500 text-sm">
              {errors.fluorescence.message}
            </p>
          )}
        </div>

        {/* Carat */}
        <div className="col-span-2 md:col-span-1 grid grid-cols-2 gap-2">
          <label className="block text-gray-700 font-semibold col-span-2">
            Carat *
          </label>
          <input
            type="number"
            step="0.01"
            placeholder="From Carat"
            className="p-2 border rounded"
            {...register("fromCarat", {
              required: "From Carat is required",
              min: { value: 0, message: "Carat must be positive" },
            })}
          />
          <input
            type="number"
            step="0.01"
            placeholder="To Carat"
            className="p-2 border rounded"
            {...register("toCarat", {
              required: "To Carat is required",
              min: { value: 0, message: "Carat must be positive" },
            })}
          />
          {(errors.fromCarat || errors.toCarat) && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.fromCarat?.message || errors.toCarat?.message}
            </p>
          )}
        </div>

        {/* Clarity */}
        <div className="col-span-2 md:col-span-1 grid grid-cols-2 gap-2">
          <label className="block text-gray-700 font-semibold col-span-2">
            Clarity *
          </label>
          <select
            className="p-2 border rounded"
            {...register("fromClarity", {
              required: "From Clarity is required",
            })}
          >
            <option value="">From Clarity</option>
            <option value="FL">FL (Flawless)</option>
            <option value="IF">IF (Internally Flawless)</option>
            <option value="VVS1">VVS1 (Very Very Slightly Included 1)</option>
            <option value="VVS2">VVS2 (Very Very Slightly Included 2)</option>
            <option value="VS1">VS1 (Very Slightly Included 1)</option>
            <option value="VS2">VS2 (Very Slightly Included 2)</option>
            <option value="SI1">SI1 (Slightly Included 1)</option>
            <option value="SI2">SI2 (Slightly Included 2)</option>
            <option value="I1">I1 (Included 1)</option>
            <option value="I2">I2 (Included 2)</option>
          </select>
          <select
            className="p-2 border rounded"
            {...register("toClarity", { required: "To Clarity is required" })}
          >
            <option value="">To Clarity</option>
            <option value="FL">FL (Flawless)</option>
            <option value="IF">IF (Internally Flawless)</option>
            <option value="VVS1">VVS1 (Very Very Slightly Included 1)</option>
            <option value="VVS2">VVS2 (Very Very Slightly Included 2)</option>
            <option value="VS1">VS1 (Very Slightly Included 1)</option>
            <option value="VS2">VS2 (Very Slightly Included 2)</option>
            <option value="SI1">SI1 (Slightly Included 1)</option>
            <option value="SI2">SI2 (Slightly Included 2)</option>
            <option value="I1">I1 (Included 1)</option>
            <option value="I2">I2 (Included 2)</option>
          </select>
          {(errors.fromClarity || errors.toClarity) && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.fromClarity?.message || errors.toClarity?.message}
            </p>
          )}
        </div>

        {/* Ratio */}
        <div className="col-span-2 md:col-span-1 grid grid-cols-2 gap-2">
          <label className="block text-gray-700 font-semibold col-span-2">
            Ratio *
          </label>
          <input
            type="text"
            placeholder="Min Ratio"
            className="p-2 border rounded"
            {...register("minRatio", { required: "Min Ratio is required" })}
          />
          <input
            type="text"
            placeholder="Max Ratio"
            className="p-2 border rounded"
            {...register("maxRatio", { required: "Max Ratio is required" })}
          />
          {(errors.minRatio || errors.maxRatio) && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.minRatio?.message || errors.maxRatio?.message}
            </p>
          )}
        </div>
        {/* Budget */}
        <div className="col-span-2 md:col-span-1 grid grid-cols-2 gap-2">
          <label className="block text-gray-700 font-semibold col-span-2">
            Budget($) *
          </label>
          <input
            type="text"
            placeholder="Min Budget"
            className="p-2 border rounded"
            {...register("minBudget", { required: "Min Budget is required" })}
          />
          <input
            type="text"
            placeholder="Max Budget"
            className="p-2 border rounded"
            {...register("maxBudget", { required: "Max Budget is required" })}
          />
          {(errors.minBudget || errors.maxBudget) && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.minBudget?.message || errors.maxBudget?.message}
            </p>
          )}
        </div>

        {/* Color */}
        <div className="col-span-2 md:col-span-1 grid grid-cols-2 gap-2">
          <label className="block text-gray-700 font-semibold col-span-2">
            Color *
          </label>
          <select
            className="p-2 border rounded"
            {...register("fromColor", { required: "From Color is required" })}
          >
            <option value="">From Color</option>
            <option value="D">D (Colorless)</option>
            <option value="E">E (Colorless)</option>
            <option value="F">F (Colorless)</option>
            <option value="G">G (Near Colorless)</option>
            <option value="H">H (Near Colorless)</option>
            <option value="I">I (Near Colorless)</option>
            <option value="J">J (Faint Yellow)</option>
            <option value="">k </option>
          </select>
          <select
            className="p-2 border rounded"
            {...register("toColor", { required: "To Color is required" })}
          >
            <option value="">To Color</option>
            <option value="D">D (Colorless)</option>
            <option value="E">E (Colorless)</option>
            <option value="F">F (Colorless)</option>
            <option value="G">G (Near Colorless)</option>
            <option value="H">H (Near Colorless)</option>
            <option value="I">I (Near Colorless)</option>
            <option value="J">J (Faint Yellow)</option>
            <option value="k">k </option>
          </select>
          {(errors.fromColor || errors.toColor) && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.fromColor?.message || errors.toColor?.message}
            </p>
          )}
        </div>
        {/* Message */}
        <div className="col-span-2 md:col-span-1">
          <label className="block text-gray-700 font-semibold mb-1">
            Message *
          </label>
          <textarea
            className="w-full p-2 border rounded"
            placeholder="Please enter your message"
            {...register("message", { required: "Message is required" })}
          />
          {errors.message && (
            <p className="text-red-500 text-sm">{errors.message.message}</p>
          )}
        </div>

        {/* Buttons */}
<div className="col-span-2 mt-4 flex flex-wrap gap-2 sm:justify-between">
  {/* Submit Button */}
  <button
    type="submit"
    disabled={isSubmitting}
    className={`flex-1 p-3 rounded-md font-semibold ${
      isSubmitting
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-indigo-600 text-white hover:bg-indigo-700"
    }`}
  >
    {isSubmitting ? "Submitting..." : "Submit Customization"}
  </button>

  {/* Clear Button */}
  <button
    type="button"
    onClick={() => {
      document.querySelector("form").reset(); // Clear the form
    }}
    className="flex-1 p-3 rounded-md font-semibold bg-gray-200 text-black hover:bg-gray-300"
  >
    Clear
  </button>

  {/* Cancel Button */}
  <button
    type="button"
    onClick={() => setShowPopup(false)}
    className="flex-1 p-3 rounded-md font-semibold bg-red-500 text-white hover:bg-red-600"
  >
    Cancel
  </button>
</div>

      </form>
    </>
  );
}

export default CustomizationForm;
